import {Box, TextField, Typography} from '@mui/material';
import React from 'react';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import {
  activateAllCards,
  addNote,
  deactivateAllCards,
  openModal,
} from '../actions';
import {useFormInput} from '../utils/utilities';
import CardsTab from './CardsTab';
import CustomButton from './CustomButton';
import PaymentsTable from './CustomTables/PaymentsTable';
import CustomerGaragesTable from './CustomTables/CustomerGaragesTable';

const CustomerDetailsTab = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const {customerPayments} = useSelector(s => s.payments);
  const {notes} = useSelector(s => s.customers);
  const {customerGarages} = useSelector(s => s.garages);
  const note = useFormInput('');

  const onActivate = () => {
    dispatch(activateAllCards(params.id));
  };

  const onDeactivate = () => {
    dispatch(deactivateAllCards(params.id));
  };

  const onAddPayment = () => {
    dispatch(openModal('PaymentModal', {customerId: params.id}));
  };

  const onAddGarage = () => {
    dispatch(openModal('CustomerGarageModal', {customerId: params.id}));
  };

  const addComment = e => {
    e.preventDefault();
    dispatch(addNote(params.id, note.value));
    note.manuallyChange('');
  };

  return (
    <>
      <Box display="flex" gap="1rem" mb="1rem" alignItems="center">
        <Typography variant="h6" mr="auto" fontWeight="bold">
          Cards
        </Typography>
        <CustomButton onClick={onActivate}>Activate All Cards</CustomButton>
        <CustomButton color="quaternary" onClick={onDeactivate}>
          Deactivate All Cards
        </CustomButton>
      </Box>
      <CardsTab />
      <Box mt="2rem">
        <PaymentsTable payments={customerPayments} onAdd={onAddPayment} />
      </Box>
      <Box mt="2rem">
        <CustomerGaragesTable
          garages={customerGarages}
          onAdd={onAddGarage}
          customerId={params.id}
        />
      </Box>
      <Box mt="2rem" display="flex">
        <Box border="1px solid #ccc" p="1rem" borderRadius="8px" width="600px">
          <Typography fontWeight="bold" mb="1rem">
            Notes
          </Typography>
          <form onSubmit={addComment}>
            {notes.map(item => (
              <Box
                key={item.notesId}
                bgcolor="#ccc"
                borderRadius="8px"
                mb="10px"
                p="10px">
                <Typography mb="10px" fontWeight="bold" color="#1976d2">
                  {item.customer}
                </Typography>
                <Typography>{item.note}</Typography>
              </Box>
            ))}
            <TextField
              {...note}
              required
              label="Add note"
              fullWidth
              multiline
              minRows={3}
            />
            <Box mt="1rem">
              <CustomButton type="submit">Comment</CustomButton>
            </Box>
          </form>
        </Box>
      </Box>
    </>
  );
};

export default CustomerDetailsTab;
